import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'
import 'bootstrap-fileinput'
import 'bootstrap-fileinput/themes/fa/theme'

class FileUploadComponent {
    
    /**
     * Construct module
     * @param inputs
    */
    constructor(inputs) {
        
        /**
         * File upload inputs
         * @type object
        */
        this.inputs = inputs
        
        /**
         * Original options parameters for custom datepicker
         * @type {object}
        */
        this.options = {
            allowedFileExtensions: ['csv', 'doc', 'docx', 'odp', 'ods', 'odt', 'pdf', 'ppt', 'pptx', 'rtf', 'xls', 'xlsx'],
            layoutTemplates: {
                actionZoom: '',
                footer: `<div class="file-thumbnail-footer">
                    <div class="file-caption-name" style="width:{width}">{caption}</div>
                </div>`
            },
            showCaption: false,
            showClose: true,
            theme: 'fa',
            uploadAsync: false
        }
        
        this.bindEvents()
        
    }
    
    /**
     * Apply file uploads
    */
    applyFileUploads() {
        this.inputs.each((i, element) => {
            this.applyFileUpload(jQuery(element).css('visibility', ''))
        })
    }
    
    /**
     * Apply file upload functionality to input
     * @param input
    */
    applyFileUpload(input) {
        
        const options = {}
        jQuery.extend(options, this.options)
        
        //Max file size
        /*const maxSize = input.data('max-file-size')
        if (maxSize) {
            options.maxFileSize = maxSize
        }*/
        
        //Upload URL
        const url = input.data('url')
        if (url) {
            options.uploadUrl = url
        }
        
        input.fileinput(options)
        
    }
  
    /**
     * Bind event listeners
    */
    bindEvents() {
        
        //Run module
        EventBus.subscribe('run-modules', this.applyFileUploads.bind(this))
        
        //Bind event for applying file upload
        EventBus.subscribe('apply-fileupload', this.applyFileUpload.bind(this))
      
    }
  
}

EventBus.subscribe('init-modules',  () => {
    
    const inputs = jQuery('.file-upload')
    
    if (inputs.length > 0) {
        new FileUploadComponent(inputs)
    }
    
})

export default FileUploadComponent